var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.source)?_c('span',{staticClass:"badge",class:`badge-${_vm.badgeType}`},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }